import { IApplicationState } from '../../types/redux';

export function getReliableLabel(state: IApplicationState) {
  return state.newbuilding.reliableLabel;
}
